import { useState } from "react";
import { downloadFile, getFileExtension, openFile, s3GetUrl } from "../service/s3Service";
import { useModal } from "../context/modalContext";
import { Button } from "primereact/button";

export function useS3Service() {
  // S3 service to download and view file
  // if file can't be viewed in browser, gooi modal telling them to download the file
  // if can be viewed in browser, open in new tab
  const [openingFile, setOpeningFile] = useState(false);
  const { showModal, hideModal } = useModal();

  async function openFileInNewTab(name: string, path: string) {
    try {
      setOpeningFile(true);
      const file = await s3GetUrl(path);
      const response = await fetch(file);
      const blob = await response.blob();
      const ext = getFileExtension(blob.type);

      if (["pdf", "jpg", "jpeg", "png", "txt"].includes(ext)) {
        openFile(name, path);
        return;
      } else {
        showModal(
          "Download file",
          <div>
            <p>
              The file you want to open can&apos;t be views in a browser. Do you want to download it
              instead?
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Button
                onClick={hideModal}
                label={"Cancel"}
                className={"p-button-outlined"}
                size={"small"}
                style={{
                  fontSize: "small",
                  color: "#ff3737",
                }}
              />
              <Button
                label="Download"
                icon="pi pi-download"
                className="p-button-outlined"
                size="small"
                style={{
                  fontSize: "small",
                  color: "#2dd36f",
                }}
                onClick={() => {
                  downloadFile(name, path);
                }}
              />
            </div>
          </div>
        );
      }
    } catch (e) {
      return "";
    } finally {
      setOpeningFile(false);
    }
  }

  const getS3Urls = async (s3Keys: string[]): Promise<string[]> => {
    if (!s3Keys || s3Keys.length === 0) return [];

    const urls = await Promise.all(
      s3Keys.map(async key => {
        try {
          return await s3GetUrl(key);
        } catch (error) {
          console.error("Error fetching S3 URL:", error);
          return "";
        }
      })
    );

    return urls.filter(url => url); // Filter out any empty URLs
  };

  const getS3Url = async (s3Key: string): Promise<string> => {
    if (!s3Key) return "";

    try {
      return await s3GetUrl(s3Key);
    } catch (error) {
      console.error("Error fetching S3 URL:", error);
      return "";
    }
  };

  return {
    openFileInNewTab,
    openingFile,
    getS3Urls,
    getS3Url,
  };
}
